<template>
  <div class="page flex-v">
    <div class="title flex flex-pack-justify">
        <span>{{title}}</span>
        <div class="flex-align-center">
            <img src="../assets/img/icon_list.png">
            <span>我的课程</span>
        </div>
    </div>
    <div class="contnet flex flex-pack-justify">
        <!-- 播放器   @contextmenu.prevent="show1($event)"-->
        <div class="flex-1 playvideo"  @contextmenu.prevent="show1($event)">
                <!-- <video :src="videoSrc"  controls="controls" playbackRate="0.5" poster="../assets/img/pic.png">
                    您的浏览器不支持 video 标签。
                </video> -->
            <div class="player" v-if="!showAlert">
                <video-player
                  class="vjs-custom-skin"
                  ref="videoPlayer"
                  :options="playerOptions"
                  :playsinline="true"
                  @timeupdate="onPlayerTimeupdate($event)"
                  @pause="onpause"
                  @play="onplay"
                  @error="onerror"
                  @abort="onabort"
                  @ended="onended"
                  @seeked="onseeked"
                >
                <!-- @canplaythrough="oncanplaythrough" -->
                <!-- @loadeddata="onPlayerLoadeddata($event)" -->
                </video-player>
            </div>
        </div>
        <div class="courses" @contextmenu.prevent="show1()">
            <CourseMenu @play='play' @open='loadData' :playid='playId' :course='course' :index='index'  v-for='(course,index) in courses' :key='course.id'/>
        </div>
    </div>
    <!-- <div class="message" v-if="showAlert">
        <div class="header"><span>温馨提示</span></div>
        <div class="content">
            <div>{{alertMsg}}</div>
            <div class="jump"><span class="time">{{ts}}s</span><span>  后将跳转到登录页！</span></div>
        </div>
        <hr class="line"/>
        <div class="footer">
            <div @click="goLogin">手动跳转</div>
        </div>
    </div> -->
  </div>
</template>
<script>
import CourseMenu from "../components/CourseMenu"
import cookie from '../assets/utils/cookie'
import { HeadGetAction } from '@/api/url'
import Poster from './poster'

export default {
  components: {
      CourseMenu,
  },
  data(){
    return {
      ts:10,
      showAlert: false,
      alertMsg: "用户认证已经过期，请重新登录认证！",
      // timer: null,
      courseTimer:null,
      saveLen:0,
      title:"暂未选择",
      playId: 0,
      converImg: "",
      videoSrc: "",
      playerOptions:{
        height: document.documentElement.clientHeight - 72,
        width: document.documentElement.clientWidth - 330,
        autoplay: true,
        muted: false,
        language: 'zh-CN',
        disposed: true,
        playbackRates: [0.75,1.0, 1.25, 1.5],
        notSupportedMessage: '未选择视频或此视频暂无法播放，请稍后再试',
        sources: [{
            type: "video/mp4",
            src: '',
        }],
        poster: Poster,
      },
      courses:[],
      defaultImg: "",
      courseId:0,
      playTime:0,
      timer:'',
      status:'',
      // planId:null,
    }
  },
  created() {
    this.getMyCourse();
  },
  computed: {
    player() {
        return this.$refs.videoPlayer.player
    }
  },
  mounted () {
    // this.timer = setInterval(() => {
    //   this.loginCheck();
    // }, 30000)
    window.addEventListener("beforeunload", e => {
      var playTime = Math.ceil(this.playTime/60)
      let tokenName = localStorage.getItem('bfe_t')
      let openId = localStorage.getItem("bfe_o");
      let mobile = localStorage.getItem("bfe_m");
      if(tokenName == null){
        tokenName = '';
      }
      if(openId == null){
        openId = '';
      }
      if(mobile == null){
        mobile = '';
      }
      HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
        if(res.data.code!=200){
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        }else{
          this.playTime = 0
          clearInterval(this.timer);
        }
      }).catch(error=>{
        alert('用户认证已经过期，请重新登录认证！');
        setTimeout(()=>{
           this.$router.replace("/login")
        },2000)
      });
    });
  },
  methods: {
    // loginCheck(){
    //   if (token){
    //       this.$get('/qrCode/login/'+ token).then(data=>{
    //         if (!data){
    //             this.rdLogin();
    //         }
    //     }).catch(error=>{
    //         let msg = error ||   "用户认证已经过期";
    //         this.rdLogin(msg+',请重新登录认证！');
    //     })
    //   }else{
    //      this.rdLogin();
    //   }
    // },
    // rdLogin(msg){
    //   if (!msg || msg==""){
    //       msg = "用户认证已经过期，请重新登录认证！";
    //   }
    //   clearInterval(this.timer);
    //   cookie.removeItem('bfe_t');
    //   this.showAlert = true;
    //   this.alertMsg = msg;
    //   this.ts = 10;
    //   this.timer = setInterval(() => {
    //     this.ts--;
    //     if (this.ts<=0){
    //       clearInterval(this.timer);
    //       if (this.courseTimer){
    //           clearInterval(this.courseTimer);
    //       }
    //       this.$router.replace("/login")
    //     }
    //   }, 1000)
    // },
    // goLogin(){
    //   this.$router.replace("/login")
    // },
    show1(ev){
      return false;
    },
    getMyCourse() {
      let tokenName = localStorage.getItem('bfe_t')
      let openId = localStorage.getItem("bfe_o");
      let mobile = localStorage.getItem("bfe_m");
      if(tokenName == null){
        tokenName = '';
      }
      if(openId == null){
        openId = '';
      }
      if(mobile == null){
        mobile = '';
      }
      HeadGetAction("/course/myCourses",tokenName,openId,mobile).then(data=>{
        if(data.data.code==200){
          var data = data.data.result;
          if (data){
            let cdata = [];
            data.forEach(element => {
                element["open"] = false;
                element["loadC"] = false;
                cdata.push(element);
            });
            this.courses = cdata;
          }
        }else{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        }
      }).catch(error=>{
        alert('用户认证已经过期，请重新登录认证！');
        setTimeout(()=>{
           this.$router.replace("/login")
        },2000)
      })
    },
    play(menu,course){
      if (menu.id==this.playId){
          return;
      }
      if(this.playId != 0&&this.status != 'ended'){
        var playTime = Math.ceil(this.playTime/60)
        let tokenName = localStorage.getItem('bfe_t')
        let openId = localStorage.getItem("bfe_o");
        let mobile = localStorage.getItem("bfe_m");
        if(tokenName == null){
          tokenName = '';
        }
        if(openId == null){
          openId = '';
        }
        if(mobile == null){
          mobile = '';
        }
        console.log('播放未结束切换课时'+playTime)
        HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
          if(res.data.code!=200){
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
               this.$router.replace("/login")
            },2000)
          }else{
            this.status = '';
            this.playTime = 0
            clearInterval(this.timer);
          }
        }).catch(error=>{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        });

      }
      this.title = course.name + "-" + menu.title;
      this.playId = menu.id;
      this.courseId = course.id;
      // this.planId = course.planId;
      let tokenName = localStorage.getItem('bfe_t')
      let openId = localStorage.getItem("bfe_o");
      let mobile = localStorage.getItem("bfe_m");
      if(tokenName == null){
        tokenName = '';
      }
      if(openId == null){
        openId = '';
      }
      if(mobile == null){
        mobile = '';
      }
      //获取播放地址
      HeadGetAction("/course/hour/video/url?courseId="+course.id+"&hoursId="+menu.id,tokenName,openId,mobile).then(data=>{
        var data = data.data;
        if (data.code == 200){
          this.videoSrc = data.result;
          this.playerOptions.sources[0].src = data.result;
          this.player.muted(true);
        }else{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        }
      }).catch(error=>{
        alert('用户认证已经过期，请重新登录认证！');
        setTimeout(()=>{
           this.$router.replace("/login")
        },2000)
      })
    },
    loadData(course,index){
      let isopen = this.courses[index]["open"];
      let loadC = this.courses[index]["loadC"];
      if (loadC){
        this.courses[index]["open"] = !isopen;
      }
      if (!isopen && !loadC){
        let tokenName = localStorage.getItem('bfe_t')
        let openId = localStorage.getItem("bfe_o");
        let mobile = localStorage.getItem("bfe_m");
        if(tokenName == null){
          tokenName = '';
        }
        if(openId == null){
          openId = '';
        }
        if(mobile == null){
          mobile = '';
        }
        HeadGetAction("/course/hours?courseId="+course.id,tokenName,openId,mobile).then(data=>{
          var data = data.data;
          if (data.code == 200){
            this.courses[index]["menus"] = data.result;
            this.courses[index]["loadC"] = true;
            this.courses[index]["open"] = !isopen;
          }else{
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
               this.$router.replace("/login")
            },2000)
          }
        }).catch(error=>{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        })
      }
    },
    // onPlayerLoadeddata(player) {
    //   clearInterval(this.courseTimer);
    //   this.courseTimer = setInterval(() => {
    //     this.$postform("/plan/course/incr",{courseHourId:this.playId,time:1}).then(data=>{
    //       if (!data){
    //         clearInterval(this.courseTimer);
    //       }
    //     })
    //   }, 60*1000)
    // },
    onPlayerTimeupdate(player) {
      let duration = parseInt(player.duration());
      let currentTime = parseInt(player.currentTime());
      if (currentTime == this.saveLen){
          return;
      }
      if (currentTime%30==0 || currentTime==duration){
        this.saveLen = currentTime;
        let tokenName = localStorage.getItem('bfe_t');
        let openId = localStorage.getItem("bfe_o");
        let mobile = localStorage.getItem("bfe_m");
        if(tokenName == null){
          tokenName = '';
        }
        if(openId == null){
          openId = '';
        }
        if(mobile == null){
          mobile = '';
        }
        var playTime = Math.ceil(this.playTime/60)
        HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
          if(res.data.code!=200){
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
              this.$router.replace("/login")
            },2000)
          }else{
            this.playTime = 0
            console.log('五分钟反馈后清空')
          }
        }).catch(error=>{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
            this.$router.replace("/login")
          },2000)
        });
        HeadGetAction("/course/looklen/update?hoursId="+this.playId+"&courseId="+this.courseId+"&len="+currentTime,tokenName,openId,mobile).then(res=>{
          if(res.data.code!=200){
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
               this.$router.replace("/login")
            },2000)
          }
        }).catch(error=>{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        });
      }
      if(currentTime%300==0){
        // if(this.planId!=null&&this.planId!=''){
          let tokenName = localStorage.getItem('bfe_t');
          let openId = localStorage.getItem("bfe_o");
          let mobile = localStorage.getItem("bfe_m");
          if(tokenName == null){
            tokenName = '';
          }
          if(openId == null){
            openId = '';
          }
          if(mobile == null){
            mobile = '';
          }
          var playTime = Math.ceil(this.playTime/60)
          HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
            if(res.data.code!=200){
              alert('用户认证已经过期，请重新登录认证！');
              setTimeout(()=>{
                 this.$router.replace("/login")
              },2000)
            }else{
              this.playTime = 0
            }
          }).catch(error=>{
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
               this.$router.replace("/login")
            },2000)
          });
        // }
      }
    },
    jump(){
      this.playTime++
      console.log('时间累积'+this.playTime)
    },
    // oncanplaythrough(){
    //   this.timer = setInterval(this.jump, 1000);
    // },
    onplay(){
      console.log('播放'+this.playTime)
      this.timer = setInterval(this.jump, 1000);
    },
    onpause(player){
      clearInterval(this.timer);
      console.log('暂停清空playTime')
      let duration = parseInt(player.duration());
      let currentTime = parseInt(player.currentTime());
      if(currentTime==duration){
        this.status = 'ended'
      }else{
        let tokenName = localStorage.getItem('bfe_t')
        let openId = localStorage.getItem("bfe_o");
        let mobile = localStorage.getItem("bfe_m");
        if(tokenName == null){
          tokenName = '';
        }
        if(openId == null){
          openId = '';
        }
        if(mobile == null){
          mobile = '';
        }
        var playTime = Math.ceil(this.playTime/60)
        HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
          if(res.data.code!=200){
            alert('用户认证已经过期，请重新登录认证！');
            setTimeout(()=>{
               this.$router.replace("/login")
            },2000)
          }else{
            this.playTime = 0
          }
        }).catch(error=>{
          alert('用户认证已经过期，请重新登录认证！');
          setTimeout(()=>{
             this.$router.replace("/login")
          },2000)
        });
      }
    },
    // onended(){
    //   let tokenName = localStorage.getItem('bfe_t');
    //   let openId = localStorage.getItem("bfe_o");
    //   let mobile = localStorage.getItem("bfe_m");
    //   if(tokenName == null){
    //     tokenName = '';
    //   }
    //   if(openId == null){
    //     openId = '';
    //   }
    //   if(mobile == null){
    //     mobile = '';
    //   }
    //   var playTime = Math.ceil(this.playTime/60)
    //   HeadGetAction("/plan/look/duration/add?hoursId="+this.playId+"&duration="+playTime,tokenName,openId,mobile).then(res=>{
    //     if(res.data.code!=200){
    //       alert('用户认证已经过期，请重新登录认证！');
    //       setTimeout(()=>{
    //          this.$router.replace("/login")
    //       },2000)
    //     }else{
    //       console.log('结束')
    //       this.status == 'ended'
    //       this.playTime = 0
    //       clearInterval(this.timer);
    //     }
    //   }).catch(error=>{
    //     alert('用户认证已经过期，请重新登录认证！');
    //     setTimeout(()=>{
    //        this.$router.replace("/login")
    //     },2000)
    //   });
    // },
  }
}
</script>
<style lang="less">
video::-internal-media-controls-download-button {
    display:none;
}

video::-webkit-media-controls-enclosure {
    overflow:hidden;
}

video::-webkit-media-controls-panel {
    width: calc(100% + 30px);
}
.page{
    position: fixed;
    height: 100%;
    width: 100%;
    left: 0px;
    right: 0px;
    top:0px;
    bottom: 0px;
    background-color: #1d1d1d;
    color: white;
    padding: 0px;
    .title{
        padding-left: 37px;
        padding-right: 26px;
        padding-top: 28px;
        margin:auto;
        img{
            width: 20px;
            height: 13px;
        }
    }
    .contnet{
        margin-top: 20px;
        width: 100%;
        height: 100%;
        .playvideo{
            background-color: #000000;
        }
        .courses{
            overflow: auto;
            width: 330px;
            background-color: #2a2a2a;
            padding-bottom: 100px;
        }
    }

    .message{
        width: 400px;
        height: 220px;
        background-color: #ffffff;
        border-radius: 10px;
        margin: auto;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        z-index: 9999;
        margin-left:auto;
        margin-right: auto;
        font-size: 18px;
        .header{
            height: 36px;
            background-color: #be1111;
            padding-left: 10px;
            span{
                margin: auto;
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 36px;
                letter-spacing: 0px;
                color: #ffffff;
            }
        }
        .content{
            // font-size: 26px;
            line-height: 45px;
            letter-spacing: 0px;
            color: #333333;
            margin: auto;
            text-align: center;
            padding-top: 10px;
            white-space:nowrap;
            .jump{
                font-size: 14px;
                letter-spacing: 0px;
                color: #4d4d4d;
                .time{
                    // font-size: 26px;
                    font-weight: normal;
                    letter-spacing: 0px;
                    color: #be1111;
                }
            }
        }
        .line{
            margin-top: 20px;
	        background-color: #dadada;
        }
        .footer{
            // font-size: 26px;
            padding-right: 21px;
            // padding-top: 10px;
            div{
                width: 100px;
	            height: 35px;
                background-color: #be1111;
                line-height: 35px;
                text-align: center;
                float: right;
            }
        }
    }
}

</style>



// WEBPACK FOOTER //
// src/pages/index.vue